import { Portal as MantinePortal } from '@mantine/core';

export const Portal = MantinePortal.extend({
  defaultProps: {
    reuseTargetNode: true,
  },
});
